import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { SparkRewardsSummary } from '../types'
import { transformSimplifiedQueryResult } from '@/domain/common/query'
import { useClaimableRewardsQuery } from '@/features/spark-rewards/data/useClaimableRewardsQuery'

export function useSparkRewardsSummary(): SparkRewardsSummary {
  const claimableRewardsResult = useClaimableRewardsQuery()

  const { data } = transformSimplifiedQueryResult(claimableRewardsResult, (data) => {
    const totalUsdAmount = data.reduce((acc, { rewardToken, pendingAmount, cumulativeAmount, preClaimed }) => {
      const amountToClaim = cumulativeAmount.plus(pendingAmount).minus(preClaimed)
      return acc.plus(rewardToken.toUSD(amountToClaim))
    }, NormalizedNumber.ZERO)

    return {
      totalUsdAmount,
    }
  })

  return data ?? {}
}
